export default "__VITE_ASSET__DOLNSQin__"